import React from 'react';
import { Box, Typography } from '@mui/material';
import style from './NoDataBox.module.scss';
import EmptyBox from '../../../../src/assets/noFile.svg';

const NoDataBox: React.FC<{ text: string }> = ({ text }) => (
  <div className={style.noDataBox}>
    <div className={style.noDataGrid}>
      <div style={{ margin: 0, marginBottom: '6px' }}>
        <img src={EmptyBox} alt='emptyBox' />
      </div>
      <div style={{ margin: 0 }}>
        <Box data-testid='nodata-div'>
          <Typography
            className={`kfic2-bodyText ${style.noDataText}`}
            sx={{ marginBottom: '1.5px' }}
          >
            {text}
          </Typography>
        </Box>
      </div>
    </div>
  </div>
);

export default NoDataBox;
